const MAP = {
  to_confirm: "to_confirm",
  preparation: "preparation",
  confirmed: "confirmed",
  in_progress: "in_progress",
  cancelled: "cancelled",
  completed: "completed",
  upcoming: "upcoming",
  current: "current",
  active: "active",
  open: "open",
  doing: "doing",
  done: "done",
  invitation_pending: "invitation_pending",
  to_bring: "to_bring",
  ready: "ready",
  loaded: "loaded",
  to_plan: "to_plan",
  assigned: "assigned",
  to_check: "to_check",
  not_needed: "not_needed",
  planned: "preparation",
};

export function statusLabel(ui, raw) {
  if (!raw) return "";
  const key = MAP[raw] || raw;
  return ui.status?.[key] || ui.status?.to_confirm || raw;
}
